<div class="container-fluid mt-4">
  <h4 class="mb-3">
    <i class="fi fi-rr-interrogation"></i> FAQ (კითხვები / პასუხები)
  </h4>

  <div class="row g-3 align-items-end mb-3">
    <div class="col-lg-4">
      <div class="form-floating">
        <select
          class="form-select"
          [(ngModel)]="selectedMenuPage"
          (ngModelChange)="onPageChange()"
          [disabled]="pagesLoading || !pages.length">
          <option [ngValue]="null">აირჩიე FAQ გვერდი...</option>
          <option *ngFor="let p of pages" [ngValue]="p.menu_page">
            {{ p.title }} ({{ p.menu_page }})
          </option>
        </select>
        <label>FAQ გვერდი</label>
      </div>
      <!-- <div class="text-muted small mt-1" *ngIf="selectedMenuPage">
        არჩეული menu_page: {{ selectedMenuPage }}
      </div> -->
    </div>

    <div class="col-lg-3">
      <div class="form-floating">
        <input
          class="form-control"
          [(ngModel)]="search"
          (ngModelChange)="onSearchChange()"
          placeholder="ძიება..." />
        <label>ძიება</label>
      </div>
    </div>

    <div class="col-lg-2">
      <div class="form-floating">
        <select class="form-select" [(ngModel)]="visible" (ngModelChange)="get()">
          <option value="all">ყველა</option>
          <option value="1">ჩანს</option>
          <option value="0">არ ჩანს</option>
        </select>
        <label>სტატუსი</label>
      </div>
    </div>

    <div class="col-lg-3 d-grid">
      <button class="btn btn-primary" (click)="openCreate()" [disabled]="!selectedMenuPage">
        + დამატება
      </button>
      <div class="text-muted small mt-1" *ngIf="!selectedMenuPage">
        ჯერ აირჩიე FAQ გვერდი
      </div>
    </div>
  </div>

  <app-spinner [loading]="loading || pagesLoading" text="იტვირთება..."></app-spinner>

  <div class="alert alert-info" *ngIf="!loading && selectedMenuPage && !items.length">
    ჩანაწერები ვერ მოიძებნა
  </div>

  <div class="table-responsive" *ngIf="items.length">
    <table class="table table-bordered table-hover align-middle">
      <thead>
        <tr>
          <th style="width:55px;">#</th>
          <th style="width:60px;">⇅</th>
          <th>კითხვა</th>
          <th style="width:160px;">სტატუსი</th>
          <th style="width:160px;">ქმედებები</th>
        </tr>
      </thead>

      <tbody cdkDropList [cdkDropListData]="items" (cdkDropListDropped)="drop($event)">
        <tr *ngFor="let item of items; let i = index" cdkDrag>
          <td>{{ i + 1 }}</td>

          <td class="text-center" style="cursor: grab;">
            <span cdkDragHandle title="გადმოათრიე სორტირებისთვის">☰</span>
          </td>

          <td>
            <div class="fw-semibold">{{ item.question }}</div>
            <div class="text-muted small">ID: {{ item.id }} | sort: {{ item.sort }}</div>
          </td>

          <td>
            <button
              class="btn btn-sm border rounded"
              (click)="toggleVisible(item)"
              [disabled]="togglingId === item.id">

              <span *ngIf="togglingId === item.id" class="spinner-border spinner-border-sm me-1"></span>

              <ng-container *ngIf="togglingId !== item.id">
                <i class="fi fi-rs-eye text-success" *ngIf="item.visible == 1"></i>
                <i class="fi fi-rr-eye-crossed text-danger" *ngIf="item.visible == 0"></i>
              </ng-container>

              <span class="ms-2">{{ item.visible == 1 ? 'ჩანს' : 'არ ჩანს' }}</span>
            </button>

            <span class="text-muted small ms-2" *ngIf="sorting">სორტირება ინახება...</span>
          </td>

          <td>
            <div class="d-flex gap-2">
              <button class="btn btn-sm btn-outline-primary" (click)="openEdit(item)">
                <i class="fi fi-rr-pencil"></i>
              </button>

              <button
                class="btn btn-sm btn-outline-danger"
                (click)="delete(item)"
                [disabled]="deletingIds.has(item.id)">
                <span *ngIf="deletingIds.has(item.id)" class="spinner-border spinner-border-sm"></span>
                <i *ngIf="!deletingIds.has(item.id)" class="fi fi-rr-trash"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>